const Sticky = require('sticky-js')

const StickyJs = () => {
  const sticky = new Sticky('.--sticky')
  sticky.update()
}
export default StickyJs
